module.exports = __webpack_public_path__ + "static/media/CAMSLogo.f1294299.png";